import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataReservation } from '../../data/DataReservation';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIComboBox } from '../EUI/EUIComboBox';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutModifier

    onAffiche : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    reservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    //peutModifierBlocSuiviNotaire: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    onActiveBoutonEnregistrer: false,

};

export class FicheSuiviNotaire extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffiche}
                headerText="Modifier le suivi notaire"
                type={PanelType.medium}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12" name="divSuiviNotaire">
                                    <EUIComboBox
                                        label="Suivi notaire"
                                        onChange={(event, option) => this._onMiseAJourChamp("reservation", "suiviNotaire", option.key)}
                                        options={[
                                            { key: "En attente offre de prêt", text: "En attente offre de prêt" },
                                            { key: "Retardée Délai Pinel", text: "Retardée Délai Pinel" },
                                            { key: "Pas d'info du client", text: "Pas d'info du client" },
                                            { key: "En cours de notification notaire", text: "En cours de notification notaire" },
                                            { key: "Impossible d'acter pour une raison liée au programme", text: "Impossible d'acter pour une raison liée au programme" },
                                            { key: "Client indécis", text: "Client indécis" },
                                            { key: "En attente Procuration notaire", text: "En attente Procuration notaire" },
                                            { key: "Autres motifs", text: "Autres motifs" }
                                        ]}
                                        selectedKey={this.state.reservation.suiviNotaire}
                                    />

                                    <div name="divSuiviCommentaire">
                                        <EUITextField
                                            disabled={!this.props.peutModifier}
                                            label="Commentaire"
                                            maxLength={MaxLengths.reservation.suiviNotaireCommentaire}
                                            multiline
                                            onDelayedChange={(event, newValue) => this._onMiseAJourChamp("reservation", "suiviNotaireCommentaire", newValue)}
                                            rows={5}
                                            value={this.state.reservation.suiviNotaireCommentaire}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);

        if (idOperationRenseigneeEtDifferent && idReservationRenseigneeEtDifferent) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du suivi notaire'
            });

            let ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

            ficheReservation_Simple
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.titrePanelNotaire = 'Modifier le suivi notaire';

                        //stateTemp.peutModifierBlocNotaire = this.props.peutModifierBlocNotaire;

                        stateTemp.reservation = objetData[0];

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                        this._onVerificationFormulaire();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    //_validationFormulaire(item) {
    //    let estValide = true;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        estValide = (item.idReservation !== 0 & item.idReservation !== null & this.props.peutModifier)
    //    }
    //    else {
    //        estValide = false;
    //    }

    //    return estValide;
    //}

    _onMiseAJourChamp(nomObjet, nomPropriete, valeur) {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du suivi notaire en cours'
        });

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        console.log(this.props.onAffiche)
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'SuiviNotaireReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrerSuiviNotaire" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    componentDidMount() {
        //if ((this.props.idReservation !== this.state.idReservation) && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation)) {
        //    this._chargementDonnees();
        //}
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        if ((this.props.idReservation !== this.state.idReservation) && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation) && !this.state.enCoursDeTraitement) {
            this._chargementDonnees();
        }
    }

    render() {
        return this._creationContent();
    }
}